import { skipToken } from '@tanstack/react-query';
import { trpc } from '../../utils/trpc/trpc.ts';
import { EquipmentOption, SelectedPart } from './types.ts';


interface Props {
    style?: React.CSSProperties;
    selectedEquipment: EquipmentOption | null;
    selectedPart: SelectedPart | null;
}

export function ProductInfoPanel({
    style,
    selectedEquipment,
    selectedPart,
}: Props) {

    const equipment = selectedEquipment?.type === 'cnc' && selectedPart?.product
        ? selectedEquipment.id
        : null;

    const { data: productInfo } = trpc.products.getProductInfo.useQuery(
        selectedPart?.partName ? { partName: selectedPart.partName } : skipToken,
    );

    const readiness = trpc.nightReadiness.get.useQuery(
        equipment ? { equipment } : skipToken,
        { refetchInterval: 60_000 },
    );
    const trpcUtils = trpc.useUtils();
    const setReadiness = trpc.nightReadiness.set.useMutation();
    const canPrepare = equipment == null ? false : readiness.data?.canPrepare;
    const isReadinessDisabled = canPrepare !== true;


    async function handleReadinessChange(isReady: boolean) {
        if (equipment == null) return;

        const previousReadiness = readiness.data;
        await trpcUtils.nightReadiness.get.cancel({ equipment });
        trpcUtils.nightReadiness.get.setData(
            { equipment },
            current => current ? { ...current, isReady } : current,
        );

        try {
            await setReadiness.mutateAsync({ equipment, isReady });
            await readiness.refetch();
        } catch (error) {
            trpcUtils.nightReadiness.get.setData({ equipment }, previousReadiness);
            console.error('Failed to set night readiness:', error);
            alert('Failed to set night readiness.');
        }
    }


    if (!selectedPart?.partName) {
        return null;
    }
    return (
        <div style={{ ...style, display: 'flex', flexDirection: 'column', alignItems: 'end' }}>
            <div>{`Target count day: ${productInfo?.targetCountDay ?? 'N/A'}`}</div>
            <div>{`Target count night: ${productInfo?.targetCountNight ?? 'N/A'}`}</div>
            <label style={{ color: canPrepare === false ? 'gray' : undefined }}>
                <input
                    type='checkbox'
                    checked={readiness.data?.isReady ?? false}
                    disabled={isReadinessDisabled}
                    onChange={(event) => handleReadinessChange(event.target.checked)}
                />
                Prepared for night production
            </label>
        </div>
    );
}
